import { CancelToken } from 'axios'
import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'

export const getAvailableModulesService = (
  reportId: string,
  cancelToken?: CancelToken,
) => {
  return apiInstance.get(ApiPathConfig.AVAILABLE_MODULES(reportId), {
    cancelToken,
  })
}
